export const formatTime = (value) => {
    if (typeof value !== 'number') return null;
    return value < 10 ? `0${value}` : `${value}`;
};
